<template>
  <div class="tinymce-container editor-container">
    <textarea class="tinymce-textarea" :id="tinymceId"></textarea>
    <div class="editor-custom-btn-container">
      <editorImage
        color="#1890ff"
        class="editor-upload-btn"
        @successCBK="imageSuccessCBK"
      ></editorImage>
    </div>
  </div>
</template>

<script>
import editorImage from './components/editorImage';
import '../../../static/tinymce4.7.5/langs/zh_CN';
import { getToken } from '../../utils/auth';
import { uploadVideo } from '../../api/fileUpload';

const plugins = [
  `advlist anchor autolink autosave code codesample colorpicker colorpicker
  contextmenu directionality emoticons fullscreen hr image imagetools importcss insertdatetime
  legacyoutput link lists media nonbreaking noneditable pagebreak paste preview print save searchreplace
  spellchecker tabfocus table template textcolor textpattern visualblocks visualchars wordcount`,
];
const toolbar = [
  `bold italic underline strikethrough alignleft aligncenter
  alignright outdent indent  blockquote undo redo removeformat code`,
  `hr bullist numlist link image charmap	 preview anchor pagebreak
    fullscreen insertdatetime media table forecolor backcolor fontsizeselect`,
];
export default {
  name: 'tinymce',
  components: { editorImage },
  props: {
    id: {
      type: String,
    },
    value: {
      type: String,
      default: '',
    },
    toolbar: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    menubar: {
      default: 'file edit insert view format table',
    },
    height: {
      type: Number,
      required: false,
      default: 360,
    },
    width: {
      type: Number,
      required: false,
      default: 720,
    },
  },
  data() {
    return {
      hasChange: false,
      hasInit: false,
      mvUrl: '',
      tinymceId: this.id || 'vue-tinymce-' + +new Date(),
    };
  },
  watch: {
    value(val) {
      if (!this.hasChange && this.hasInit) {
        this.$nextTick(() =>
          window.tinymce.get(this.tinymceId).setContent(val)
        );
      }
    },
  },
  mounted() {
    this.initTinymce();
  },
  activated() {
    this.initTinymce();
  },
  deactivated() {
    this.destroyTinymce();
  },
  methods: {
    initTinymce() {
      const _this = this;
      window.tinymce.init({
        selector: `#${this.tinymceId}`,
        content_style: 'p {margin: 0px; border:0px ; padding: 0px}',
        width: this.width,
        height: this.height,
        language: 'zh_CN',
        body_class: 'panel-body ',
        content_css:
          '../../../static/tinymce4.7.5/skins/lightgray/content.min.css',
        object_resizing: false,
        toolbar: this.toolbar.length > 0 ? this.toolbar : toolbar,
        menubar: false,
        plugins: plugins,
        end_container_on_empty_block: true,
        powerpaste_word_import: 'clean',
        code_dialog_height: 450,
        code_dialog_width: 1000,
        advlist_bullet_styles: 'square',
        advlist_number_styles: 'default',
        imagetools_cors_hosts: ['www.tinymce.com', 'codepen.io'],
        default_link_target: '_blank',
        link_title: false,
        mvUrl: '124',
        fontsize_formats:
          '12px 13px 14px 15px 16px 17px 18px 20px 22px 24px 26px 30px 35px 40px 50px',
        style_formats: [
          {
            title: '行高',
            items: [
              {
                title: '1倍行距',
                block: 'p',
                styles: [
                  {
                    'line-height': '1.0',
                  },
                ],
              },
            ],
          },
        ],
        style_formats_merge: false,
        style_formats_autohide: true,
        file_picker_types: 'media',
        file_picker_callback: (callback, value, meta) => {
          let that = this;
          console.log(this.mvUrl);
          if (meta.filetype == 'media') {
            let input = document.createElement('input'); //创建一个隐藏的input
            input.setAttribute('type', 'file');

            input.onchange = function () {
              let file = this.files[0]; //选取第一个文件
              let formData = new FormData();
              formData.append('file', file);
              uploadVideo(formData, getToken())
                .then((response) => {
                  callback(response.data);
                  //return response.data;
                })
                .catch((error) => {
                  this.$message.error('上传失败，请重新上传');
                  console.log('报错', error);
                });
              //callback(this.mvUrl);
            };
            //触发点击
            input.click();
          }
        },
        init_instance_callback: (editor) => {
          if (_this.value) {
            editor.setContent(_this.value);
          }
          _this.hasInit = true;
          editor.on('NodeChange Change KeyUp SetContent', () => {
            this.hasChange = true;
            this.$emit('input', editor.getContent());
          });
        },
      });
    },
    destroyTinymce() {
      if (window.tinymce.get(this.tinymceId)) {
        window.tinymce.get(this.tinymceId).destroy();
      }
    },
    setContent(value) {
      window.tinymce.get(this.tinymceId).setContent(value);
    },
    getContent() {
      window.tinymce.get(this.tinymceId).getContent();
    },
    uploadV(file) {
      let formData = new FormData();
      formData.append('file', file);
      uploadVideo(formData, getToken())
        .then((response) => {
          this.mvUrl = response.data;
          //return response.data;
        })
        .catch((error) => {
          this.$message.error('上传失败，请重新上传');
          console.log('报错', error);
        });
    },
    // imageSuccessCBK(arr) {
    //   const _this = this
    //   arr.forEach(v => {
    //     window.tinymce.get(_this.tinymceId).insertContent(`<img class="wscnph" src="${v.url}" >`)
    //   })
    // }
    imageSuccessCBK(arr) {
      const _this = this;
      arr.forEach((v) => {
        window.tinymce
          .get(_this.tinymceId)
          .insertContent(`<img class="wscnph" src="${v.fileUrl}" >`);
      });
    },
  },
  beforeDestroy() {
    console.log('beforeDestroy');
    this.destroyTinymce();
  },
  destroyed() {
    this.destroyTinymce();
  },
};
</script>

<style scoped>
.tinymce-container {
  position: relative;
}

.tinymce-container >>> .mce-fullscreen {
  z-index: 10000;
}

.tinymce-textarea {
  visibility: hidden;
  z-index: -1;
}

.editor-custom-btn-container {
  position: absolute;
  right: 10px;
  top: 2px;
  /*z-index: 2005;*/
}

.editor-upload-btn {
  display: inline-block;
}
</style>
